// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ApiHandler, createHandlerChainRunnerOptionalParameter } from "@insite/client-framework/HandlerCreator";
import logger from "@insite/client-framework/Logger";
import {
    CustomerPartNumbersApiParameter,
    CustomerPartNumbersModel,
    getCustomerPartNumbers,
} from "@steiner/App/Services/CustomerPartNumbersServices";

type HandlerType = ApiHandler<CustomerPartNumbersApiParameter, CustomerPartNumbersModel>;

export const DispatchBeginLoadingCustomerProducts: HandlerType = props => {
    props.dispatch({
        type: "xCustomerPartNumbers/BeginLoadingCustomerPartNumbers",
        isLoading: true,
    } as any);
};

export const PopulateApiParameters: HandlerType = props => {
    props.apiParameter = {
        ...props.parameter,
    };
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await getCustomerPartNumbers(props.apiParameter);
    } catch (error) {
        props.dispatch({
            type: "xCustomerPartNumbers/FailedCustomerPartNumbers",
        } as any);
        return false;
    }
};

export const DispatchCompleteLoadingCustomerPartNumbers: HandlerType = props => {
    props.dispatch({
        type: "xCustomerPartNumbers/CompleteLoadingCustomerPartNumbers",
        value: props.apiResult,
    } as any);
};

export const chain = [
    DispatchBeginLoadingCustomerProducts,
    PopulateApiParameters,
    RequestDataFromApi,
    DispatchCompleteLoadingCustomerPartNumbers,
];

const loadCustomerPartNumbers = createHandlerChainRunnerOptionalParameter(chain, {}, "loadCustomerPartNumbers");

export default loadCustomerPartNumbers;
